import { Sector, useSectorQuery } from 'graphql-common';
import { ErrorLike } from '@apollo/client';

type Args = {
  id: string;
};

export type UseSectorQueryHookResult = {
  data: Sector | null | undefined;
  error: ErrorLike | undefined;
  firstLoading: boolean;
  loading: boolean;
  refetch: () => Promise<unknown>;
};

export default function useSectorQueryHook(
  args: Args,
): UseSectorQueryHookResult {
  const { id } = args;
  const query = useSectorQuery({
    skip: !id,
    variables: {
      id,
    },
    fetchPolicy: 'cache-and-network',
  });
  const { data: queryData, refetch, loading, error, previousData } = query;
  const data = queryData || previousData;
  const firstLoading = loading && queryData === undefined;

  return {
    data: data?.data as Sector,
    error,
    firstLoading,
    loading,
    refetch,
  };
}
